/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetFormSubmission } from '../models/GetFormSubmission';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GetFormSubmissionsService {

    /**
     * @returns GetFormSubmission
     * @throws ApiError
     */
    public static getFormSubmissionsRetrieve({
        link,
    }: {
        link: string,
    }): CancelablePromise<GetFormSubmission> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/get_form_submissions/{link}/',
            path: {
                'link': link,
            },
        });
    }

}
